import styled from "styled-components";

export const FinePrint = styled.small`
  margin-bottom: 38px;
  align-self: center;
`;
